import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg, statusOf } from "@/lib/api";
import { afterLoginPath, useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/common";

const GOOGLE_FAIL = "Google sign-in didn't complete. Try again.";

export default function AuthCallback() {
  const nav = useNavigate();
  const { signIn, refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const m = window.location.hash.match(/session_id=([^&]+)/);
    window.history.replaceState(null, "", window.location.pathname);
    const fail = async (e) => {
      await refresh();
      nav("/signin", { replace: true, state: { error: statusOf(e) === 403 ? errMsg(e) : GOOGLE_FAIL } });
    };
    if (!m) return void fail();
    api.post("/auth/google", { session_id: decodeURIComponent(m[1]) })
      .then(({ data }) => nav(afterLoginPath(signIn(data)), { replace: true }))
      .catch(fail);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <div className="min-h-screen bg-q-bg"><Loader label="Signing you in…" /></div>;
}
